/**********
 * KNB for apollo | merchant webview
 *********/
var Titans = require('../titans/titans');
var dpzeusAPI = require('./api');
var shareConst = require('./share');
var logEvent = require('../common/log');
var promisify = require('../promisify');
var version = require('../common/version');
var mixin = require('../common/mixin');
var semver = require('../common/semver');
var getUA = require('../common/get-ua');
// brige 发送消息的方法
var selfUtils = require('./utils');
var _send = selfUtils._send;
var _sendMessage = selfUtils._sendMessage;
var uaInfo = getUA.internal();
var isAndroid = typeof uaInfo === 'object' ? uaInfo.osName === 'android' : false;
var lua = navigator.userAgent.toLowerCase();
var isDpmer = ["com.dianping.merchant.mobile", "com.dianping.mp.mobile"].some(function (key) { return lua.indexOf(key) > -1; });
var isApollo = ["com.dianping.ba.crm.Mobile", "com.dianping.apollo.crm", "com.dianping.apollo.mobile", "com.dianping.crm"].some(function (key) { return lua.indexOf(key) > -1; });

var KNB = {
    __version__: version,
    config: function (opts) {
        Titans.config(opts)
    },
    ready: function (callback) {
        var self = this;
        _send('ready', {
            success: function () {
                self._isReady = true;
                callback();
            }
        });
    },
    getUA: getUA,
    // adapter-----start
    isApiSupported: function(opts){
        var success = opts.success, isSupport = false;
        if (this[opts.apiName] instanceof Function) {
            isSupport = true;
        }
        // _sendMessage('isApiSupported', opts, function (result) {
        //     if (result.status == 'success') {
        //         success && success(true);
        //     } else {
        //         fail && fail(false);
        //     }
        // });
        success && success(isSupport);
    },
    getNetworkType: function(opts){
        var success = opts.success, fail = opts.fail;
         _sendMessage('getNetworkType', opts, function (result) {
            result.networkType = result.type
            if (result.status == 'success') {
                success && success(result);
            } else {
                fail && fail(result);
            }
        });
    },
    openWebview: function (opts) {
        var url = opts.url;
        var extra = mixin({}, opts.extra||{}, opts.qs||{});
        var query = mixin({}, opts.query||{});
        var queryString = '';
        if (Object.keys(extra).length) {
            url += '?' + selfUtils.convertUrlParams(extra);
            delete opts.extra;
            opts.url = url;
        }
        if (Object.keys(query).length) {
            queryString = '&' + selfUtils.convertUrlParams(query);
            delete opts.query;
        }
        if (!/^https:|^\/\//i.test(opts.url)) {
          return _send('openScheme', opts);
        } else if (window.TITANS_WEB_VIEW_URI) {
          opts.url = (window.TITANS_WEB_VIEW_URI) + "?url=" + (encodeURIComponent(opts.url)) + queryString
        } else if (isDpmer) {
          opts.url = "dpmer://web?url=" + (encodeURIComponent(opts.url)) + queryString
        } else if (isApollo) {
          opts.url = "dpcmr://web?url=" + (encodeURIComponent(opts.url)) + queryString
        }
        _send('openScheme', opts);
    },
    jumpWebview: function (opts) {
        var url = opts.url;
        var extra = mixin({}, opts.extra||{}, opts.qs||{});
        var query = mixin({}, opts.query||{});
        var queryString = '';
        if (Object.keys(extra).length) {
            url += '?' + selfUtils.convertUrlParams(extra);
            delete opts.extra;
            opts.url = url;
        }
        if (Object.keys(query).length) {
            queryString = '&' + selfUtils.convertUrlParams(query);
            delete opts.query;
        }
        if (!/^https:|^\/\//i.test(opts.url)) {
          return _send('openScheme', opts);
        } else if (window.TITANS_WEB_VIEW_URI) {
          opts.url = (window.TITANS_WEB_VIEW_URI) + "?url=" + (encodeURIComponent(opts.url)) + queryString
        } else if (isDpmer) {
          opts.url = "dpmer://web?url=" + (encodeURIComponent(opts.url)) + queryString
        } else if (isApollo) {
          opts.url = "dpcmr://web?url=" + (encodeURIComponent(opts.url)) + queryString
        }
        opts.toHome = opts.toHome ? 1 : 0;
        _send('jumpToScheme', opts);
    },
    closeWebview: function (opts) {
        _send('closeWindow', opts)
    },
    share: function (opts) {
        opts = mixin({}, opts);
        opts.shareType = -1; // only WEB type
        if (!(opts.channel instanceof Array)) {
            opts.feed = 0;
        }else {
            // https://wiki.sankuai.com/pages/viewpage.action?pageId=1199043354
            // feed 顺序问题
            opts.feed = Titans.util.parseFeed(opts.channel)
        }
        var miniProgram = opts.miniProgram
        if (isAndroid && typeof miniProgram === 'object') {
            var miniProgramId = miniProgram.id;
            var miniProgramPath = miniProgram.path;
            var miniProgramImage = miniProgram.image;
            var miniProgramType = miniProgram.type;
            opts = mixin({}, opts, {miniProgramId: miniProgramId, miniProgramImage: miniProgramImage, miniProgramPath: miniProgramPath, miniProgramType: miniProgramType});
        }
        // get sharedTo
        var originSuccess = opts.success;
        opts.success = function(res) {
            if(res.channel != undefined) {
                res.sharedTo = {};
                Object.keys(shareConst).forEach(function (ele, i) {res.sharedTo[ele] = (i === res.channel)});
            }
            originSuccess(res);
        }
        _send('share', opts);
    },
    configShare: function (opts) {
        var self = this;
        opts = mixin({}, opts);
        this.setRRButton({
            icon: 'H5_Share',
            handle: function () {
                opts.handle && opts.handle();
                self.share(opts);
            }
        });
    },
    setNavButtons: function (opts) {
        var self = this
        if (!(opts instanceof Array)) {
            opts = [opts];
        }
        opts.forEach(function (btnConfig) {
            var method = 'set' + btnConfig.position + 'Button';
            delete btnConfig.position;
            if (btnConfig.type === 'base64') {
                try {
                    btnConfig.icon = btnConfig.icon.split('data:image/png;base64,')[1];
                } catch (e) {
                    console.error('get base64 icon failed');
                    throw new Error('get base64 icon failed')
                }
            }
            self[method](btnConfig);
        });
    },
    getCity: function (opts) {
        _send('getCityId', opts)
    },
    getLocationCity: function (opts) {
        _send('getCityId', opts)
    },
    toast: function(opts){
        opts.title = opts.content || '';
        opts.timeout  = 2000;
        if(opts.duration == 0){
            opts.timeout  = 2000;
        }
        if(opts.duration == 1){
            opts.timeout  = 3500;
        }
        _send('toast', opts);
    },
    scanQRCode: function(opts){
        var success = opts.success;
        opts.success = function(res) {
            success(mixin({}, res, {
                scanResult: res.value
            }));
        };
        _send('scanQRCode', opts);
    },
    uploadMedia: function(opts){
        var callback = opts.callback || opts.handle;
        _sendMessage('uploadMedia', opts, function(data){
            callback(data);
        });
    },
    // adapter-----end
};

// 在 knb 上是绑定在 share 上的
(function () {
    for (var key in shareConst) {
        KNB.share[key] = shareConst[key];
    }
})();

// 常规实现
dpzeusAPI.forEach(function (name) {
    if (name && !KNB[name]) {
        KNB[name] = function (options) {
            _send(name, options);
        }
    }
});

// 直接调用 Titans 的api
['getNetworkType','remove', 'pureUse',
'checkAuthorization', 'setResult', 
'getApisVersion', 'setSearchBar', 'lxlog', 'use',
// update 20180203
'subscribe', 'unsubscribe', 'publish','pickContact',
'autoLock', 'vibrate', 'actionSheet', 'shark', 'shareImage', 'capture', 
'setImageTitle', 'getResult', 'getDeviceInfo',
'chooseMedia', 'playMedia', 'editMedia'
].forEach(function (api) {
    KNB[api] = Titans[api].bind(Titans);
});

KNB.Semver = semver;

//被引用统计
logEvent('dpzeus', KNB.__version__);
promisify(KNB);
module.exports = KNB;
